
import React from 'react';
import { NavLink as RouterNavLink, Link } from 'react-router-dom';
import { cn } from "@/lib/utils";

// Desktop NavLink
export const NavLink = React.forwardRef<
  React.ElementRef<typeof RouterNavLink>,
  React.ComponentPropsWithoutRef<typeof RouterNavLink>
>(({ className, children, ...props }, ref) => {
  return (
    <RouterNavLink
      ref={ref}
      className={({ isActive }) =>
        cn(
          "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-1.5 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50",
          "relative after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:translate-y-1",
          "after:scale-x-0 hover:after:scale-x-100 after:bg-primary after:transition-transform after:duration-300 after:ease-in-out",
          isActive
            ? "after:scale-x-100 text-primary"
            : "text-foreground",
          className
        )
      }
      {...props}
    >
      {children}
    </RouterNavLink>
  )
});
NavLink.displayName = "NavLink";

// Mobile NavLink
interface MobileNavLinkProps {
  to: string;
  className?: string;
  children: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
}

export const MobileNavLink: React.FC<MobileNavLinkProps> = ({ 
  className, 
  children, 
  onOpenChange, 
  to, 
  ...props 
}) => {
  return (
    <Link
      onClick={() => onOpenChange && onOpenChange(false)}
      to={to}
      className={cn("flex w-full items-center font-medium text-foreground hover:text-primary transition-colors duration-200", className)}
      {...props}
    >
      {children}
    </Link>
  )
};
